export default {"src":"/_next/static/media/empty-image.27320d23.svg","height":92,"width":139,"blurWidth":0,"blurHeight":0};